import { presignedS3Uploader } from './presignedS3Uploader.js';
/** Shared presign → PUT → process path for profile and community image fields. */
export function profileImageUploader(options) {
    return presignedS3Uploader({
        presign: async (file, signal) => ({
            ...(await options.presign(file, signal)),
            contentType: file.type || 'image/jpeg',
        }),
        finalize: async (_file, signed) => {
            if (!signed.key)
                throw new Error('Missing image key');
            return signed.key;
        },
        awaitProcessed: async (key, signal) => {
            const url = await options.process(key, signal);
            return options.persist ? options.persist(url, signal) : url;
        },
    });
}
//# sourceMappingURL=profileImageUploader.js.map